import API from 'services/api';

export const createNewConversation = ({
  calculationId,
}: {
  calculationId: string;
}): Promise<{
  conversationId: string;
}> => {
  return API.post(`api/accommodation/messaging/conversations/initiate`, null, {
    params: { calculationId },
  }).then(response => response?.data);
};
